var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import qs from 'qs';
import jszip from 'jszip';
import { getAll as getAllApi, destroy as destroyApi } from '../../api/invoice';
import { useInvoiceColumns } from '../../hooks/useColumns';
import { useRequest } from '../../hooks/requestHook';
import { useNotify } from '../../hooks/notificationHook';
import { useConfirm } from '../../hooks/confirmationHook';
import useFetch from '../../hooks/useFetch';
import { DeleteIcon, DownloadIcon } from '../atoms/Icons';
import PaymentTimingFilter from '../molecules/PaymentTimingFilter';
import DateRangeFilter from '../molecules/DateRangeFilter';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import Select from '../atoms/SelectField';
import PageLayout from '../atoms/PageLayout';
import { toOptions } from '../../hooks/useListItem';
import { useOffice } from '../../hooks/useOffice';
import DownloadInvoicesCSVButton from '../organisms/DownloadInvoicesCSVButton';
import { Box, Checkbox, Fab, FormControlLabel, LinearProgress, Zoom, useTheme, } from '@mui/material';
import { getBinary } from '../../api/request';
import Dialog from '../atoms/Dialog';
var PaidSelect = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, label = _a.label;
    var handleChange = React.useCallback(function (event) {
        var value = event.target.value;
        onFilterChanged(columnDef.tableData.id, value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement(Select, { fullWidth: true, margin: "none", variant: "standard", value: columnDef.tableData.filterValue || null, onChange: handleChange, label: label || '', items: [
            { text: 'All', value: '' },
            { text: 'Yes', value: 'paid' },
            { text: 'No', value: 'unpaid' },
        ] }));
};
var AdminInvoicesPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var InvoiceColumns = useInvoiceColumns();
    var destroyInvoice = useRequest(destroyApi);
    var getAll = useRequest(getAllApi);
    var notify = useNotify();
    var confirm = useConfirm();
    var tableRef = React.createRef();
    var officeListItems = useOffice().officeListItems;
    var urlQuery = React.useMemo(function () { return qs.parse(location.search.slice(1)); }, [location]);
    var orderBy = urlQuery.orderBy;
    var orderDirection = urlQuery.orderDirection;
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var _a = React.useState(false), bulkDownloadMode = _a[0], setBulkDownloadMode = _a[1];
    var _b = React.useState([]), selectedInvoices = _b[0], setSelectedInvoices = _b[1];
    var _c = React.useState(), downloadingProgress = _c[0], setDownloadingProgress = _c[1];
    var theme = useTheme();
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var defaultSort = React.useCallback(function (field) {
        if (orderBy === field &&
            (orderDirection === 'asc' || orderDirection === 'desc')) {
            return orderDirection;
        }
        return;
    }, [orderBy, orderDirection]);
    var renderOfferLists = React.useCallback(function (invoice) {
        if (invoice.orders.length === 0)
            return null;
        return invoice.offerLists.map(function (_a) {
            var id = _a.id, name = _a.name;
            return (React.createElement(Link, { key: id, to: "/admin/offer_lists/".concat(id) }, name));
        });
    }, []);
    var renderExpiredDateFilter = React.useCallback(function (props) { return React.createElement(DateRangeFilter, __assign({}, props)); }, []);
    var renderPaidSelect = React.useCallback(function (props) { return React.createElement(PaidSelect, __assign({}, props)); }, []);
    var renderPaymentTimingFilter = React.useCallback(function (props) { return React.createElement(PaymentTimingFilter, __assign({}, props)); }, []);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, InvoiceColumns.title), { filtering: true, defaultFilter: defaultFilter('title') }),
        {
            title: t('offerLists'),
            field: 'offerLists',
            render: renderOfferLists,
            filtering: true,
            sorting: false,
            defaultFilter: defaultFilter('offerLists'),
        },
        __assign(__assign({}, InvoiceColumns.office), { title: t('params.office.name'), filtering: true, sorting: false, lookup: toOptions(officeListItems), defaultFilter: defaultFilter('roaster.country.office.id') }),
        __assign(__assign({}, InvoiceColumns.communityManager), { filtering: true, sorting: false, defaultFilter: defaultFilter('roaster.communityManager') }),
        __assign(__assign({}, InvoiceColumns.billingName), { filtering: true, sorting: false, defaultFilter: defaultFilter('billingName') }),
        __assign(__assign({}, InvoiceColumns.storeName), { filtering: true, sorting: false, defaultFilter: defaultFilter('storeName') }),
        __assign(__assign({}, InvoiceColumns.personName), { filtering: true, sorting: false, defaultFilter: defaultFilter('personName') }),
        __assign(__assign({}, InvoiceColumns.paymentTimings), { filtering: true, sorting: false, filterComponent: renderPaymentTimingFilter, defaultFilter: defaultFilter('paymentTimings') }),
        __assign(__assign({}, InvoiceColumns.paymentMethod), { filtering: true, sorting: false, defaultFilter: defaultFilter('paymentMethod') }),
        __assign(__assign({}, InvoiceColumns.createdDate), { filtering: false }),
        __assign(__assign({}, InvoiceColumns.expiredDate), { filterComponent: renderExpiredDateFilter, defaultFilter: defaultFilter('expiredDate'), defaultSort: defaultSort('expiredDate') }),
        __assign(__assign({}, InvoiceColumns.total), { defaultFilter: defaultFilter('total') }),
        __assign(__assign({}, InvoiceColumns.paid), { filtering: true, filterComponent: renderPaidSelect, defaultFilter: defaultFilter('paidAt') }),
        __assign(__assign({}, InvoiceColumns.taiwanApiResponseResult), { filtering: true, sorting: false, defaultFilter: defaultFilter('taiwanApiResponse') }),
        __assign(__assign({}, InvoiceColumns.taxStatementCreatedDate), { filtering: false }),
    ]; }, [
        t,
        defaultFilter,
        renderOfferLists,
        renderPaidSelect,
        renderPaymentTimingFilter,
        renderExpiredDateFilter,
        InvoiceColumns,
        defaultSort,
        officeListItems,
    ]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'paidAt':
                    if (filter.value)
                        q[filter.value] = true;
                    break;
                case 'paymentMethod':
                    q.with_payment_method = filter.value;
                    break;
                case 'paymentTimings':
                    q.with_payment_timing = filter.value;
                    break;
                case 'offerLists':
                    q.order_items_order_offer_list_name_cont = filter.value;
                    break;
                case 'expiredDate':
                    if (filter.value.startedAt) {
                        q.expired_date_gteq = filter.value.startedAt;
                    }
                    if (filter.value.endedAt) {
                        q.expired_date_lteq = filter.value.endedAt;
                    }
                    break;
                case 'total':
                    q.total_eq = filter.value;
                    break;
                case 'taiwanApiResponse':
                    q.taiwan_api_response_raw_response_cont = filter.value;
                    break;
                case 'roaster.country.office.id':
                    q.roaster_country_office_id_in = filter.value;
                    break;
                case 'roaster.communityManager':
                    q.roaster_community_manager_name_cont = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var fetchInvoices = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
    });
    var reload = React.useCallback(function () {
        if (!tableRef.current)
            return;
        tableRef.current.onQueryChange();
    }, [tableRef]);
    var actions = React.useMemo(function () { return [
        {
            icon: function () { return React.createElement(DeleteIcon, null); },
            onClick: function (event, row) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    confirm(t('messages.deleteInvoiceConfirmTitle'), t('messages.deleteInvoiceConfirmBody'), function () { return __awaiter(void 0, void 0, void 0, function () {
                        var id, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    id = row.id;
                                    return [4 /*yield*/, destroyInvoice(id)];
                                case 1:
                                    response = _a.sent();
                                    if (!response)
                                        return [2 /*return*/];
                                    reload();
                                    notify('success', [t('messages.deleteSuccess')]);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [2 /*return*/];
                });
            }); },
        },
    ]; }, [t, confirm, notify, destroyInvoice, reload]);
    var csvParams = React.useMemo(function () {
        if (!urlQuery.filters)
            return;
        var filters = Object.entries(urlQuery.filters).map(function (_a) {
            var field = _a[0], value = _a[1];
            return ({
                column: { field: field },
                operator: '=',
                value: value,
            });
        });
        return { q: buildFilterParams({ filters: filters }) };
    }, [urlQuery.filters, buildFilterParams]);
    var selectionProps = React.useCallback(function (invoice) {
        return {
            disabled: parseFloat(invoice.total) === 0,
            checked: selectedInvoices.some(function (e) { return e.id === invoice.id; }),
        };
    }, [selectedInvoices]);
    var startDownload = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var ids, zip, _i, ids_1, id, blob, zipBlob, link, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, 7, 8]);
                    setDownloadingProgress(0);
                    ids = selectedInvoices.map(function (invoice) { return invoice.id; });
                    zip = jszip();
                    _i = 0, ids_1 = ids;
                    _a.label = 1;
                case 1:
                    if (!(_i < ids_1.length)) return [3 /*break*/, 4];
                    id = ids_1[_i];
                    return [4 /*yield*/, getBinary("/api/invoices/".concat(id, ".pdf"))];
                case 2:
                    blob = _a.sent();
                    zip.file("invoice_".concat(id.padStart(8, '0'), ".pdf"), blob);
                    setDownloadingProgress(function (oldValue) { return (oldValue !== null && oldValue !== void 0 ? oldValue : 0) + 1; });
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [4 /*yield*/, zip.generateAsync({
                        type: 'blob',
                        compression: 'DEFLATE',
                    })];
                case 5:
                    zipBlob = _a.sent();
                    link = document.createElement('a');
                    link.href = URL.createObjectURL(zipBlob);
                    link.setAttribute('download', 'invoices.zip');
                    link.click();
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    notify('error', [e_1.message]);
                    return [3 /*break*/, 8];
                case 7:
                    setDownloadingProgress(undefined);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [selectedInvoices, notify]);
    var changeBulkDownloadMode = React.useCallback(function () {
        var nextValue = !bulkDownloadMode;
        setBulkDownloadMode(nextValue);
        if (!nextValue) {
            setSelectedInvoices([]);
        }
    }, [bulkDownloadMode]);
    return (React.createElement(PageLayout, { title: t('invoices'), actions: React.createElement(Box, null,
            React.createElement(FormControlLabel, { sx: {
                    marginRight: '10px',
                }, control: React.createElement(Checkbox, { checked: bulkDownloadMode, onChange: changeBulkDownloadMode }), label: t('labels.bulkDownloadMode') }),
            React.createElement(DownloadInvoicesCSVButton, { params: csvParams })) },
        React.createElement(MaterialTable, { tableRef: tableRef, model: "invoice", columns: columns, data: fetchInvoices, detailPath: function (invoice) { return "/admin/invoices/".concat(invoice.id); }, actions: actions, options: {
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                    maxWidth: 200,
                },
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
                selection: bulkDownloadMode,
                selectionProps: selectionProps,
            }, onSelectionChange: function (rows) { return setSelectedInvoices(rows); } }),
        React.createElement(Zoom, { in: selectedInvoices.length > 0, timeout: {
                enter: theme.transitions.duration.enteringScreen,
                exit: theme.transitions.duration.leavingScreen,
            }, style: {
                transitionDelay: "".concat(theme.transitions.duration.leavingScreen, "ms"),
                position: 'fixed',
                bottom: 30,
                right: 30,
            }, unmountOnExit: true },
            React.createElement(Fab, { onClick: startDownload, color: "primary" },
                React.createElement(DownloadIcon, null))),
        downloadingProgress && (React.createElement(Dialog, { title: "", open: true, onClose: function () { return undefined; }, style: {
                minWidth: '300px',
            } },
            "downloading now...",
            React.createElement(LinearProgress, { variant: "determinate", value: (downloadingProgress / selectedInvoices.length) * 100 })))));
};
export default AdminInvoicesPage;
